import React, { useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { roleContext, LanguageContext } from "../../../libs/context";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import "./styles.css";

function ReportsMenu(props) {
  const { isOpen, onClose } = props;

  const role = useContext(roleContext);
  const language = useContext(LanguageContext);
  const location = useLocation();

  const handleItemClick = () => {
    onClose();
  };

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="profile-menu-overlay" onClick={onClose} />

      <div className="profile-menu">
        <div className="profile-menu-header">
          <h3>{language.reports || "Reports"}</h3>
          <IconButton onClick={onClose} size="small" aria-label="close">
            <CloseIcon />
          </IconButton>
        </div>

        <div className="profile-menu-items">
          <NavLink
            to="/class-reports/attendanceReports"
            className={({ isActive }) =>
              isActive ? "profile-menu-item active" : "profile-menu-item"
            }
            onClick={handleItemClick}
          >
            <img
              src="/images/blue/reports.png"
              alt="Attendance"
              className="menu-item-icon"
            />
            <span>{language.attendance || "Attendance"}</span>
          </NavLink>

          <NavLink
            to="/class-reports/assessmentReports"
            className={({ isActive }) =>
              isActive ? "profile-menu-item active" : "profile-menu-item"
            }
            onClick={handleItemClick}
          >
            <img
              src="/images/blue/reports.png"
              alt="Assessments"
              className="menu-item-icon"
            />
            <span>{language.assessments || "Assessments"}</span>
          </NavLink>
        </div>
      </div>
    </>
  );
}

export default ReportsMenu;
